import { render, staticRenderFns } from "./RoommateCard.vue?vue&type=template&id=2d6120c0&scoped=true&class=mt-4&"
import script from "./RoommateCard.vue?vue&type=script&lang=js&"
export * from "./RoommateCard.vue?vue&type=script&lang=js&"
import style0 from "./RoommateCard.vue?vue&type=style&index=0&id=2d6120c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6120c0",
  null
  
)

export default component.exports